export default "__VITE_ASSET__DAkqZFpk__"